import { TrendingAsset } from '@/types/main'

export interface TrendingAssetsBaseProps {
  assets: TrendingAsset[]
  onAssetClick?: (asset: TrendingAsset) => void
  loading?: boolean
}

export const getTypeColor = (dealType: string): string => {
  switch (dealType) {
    case 'LIQUID_TOKEN':
      return '#2ea66b' // Green
    case 'SAFT':
      return '#ac5bdb' // Purple
    case 'EQUITY':
      return '#3481ec' // Blue
    default:
      return 'rgba(45,41,35,0.72)'
  }
}

